import type { T_IconProps } from '@/types/Title';

export const MrIcon = ({ className, color }: T_IconProps) => (
  <svg
    viewBox='0 0 16 16'
    className={className}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ color }}
  >
    <path
      d='M9.33325 4.66634H6.66659C5.93325 4.66634 5.33325 5.26634 5.33325 5.99967V9.33301C5.33325 9.69967 5.63325 9.99967 5.99992 9.99967H6.66659V13.9997C6.66659 14.3663 6.96659 14.6663 7.33325 14.6663H8.66659C9.03325 14.6663 9.33325 14.3663 9.33325 13.9997V9.99967H9.99992C10.3666 9.99967 10.6666 9.69967 10.6666 9.33301V5.99967C10.6666 5.26634 10.0666 4.66634 9.33325 4.66634Z'
      fill='currentColor'
    />
    <path
      d='M7.99992 3.99967C8.7363 3.99967 9.33325 3.40272 9.33325 2.66634C9.33325 1.92996 8.7363 1.33301 7.99992 1.33301C7.26354 1.33301 6.66659 1.92996 6.66659 2.66634C6.66659 3.40272 7.26354 3.99967 7.99992 3.99967Z'
      fill='currentColor'
    />
  </svg>
);
